import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import { isInvalid } from "../utils/forms";
import ListGroup, { ListGroupItem } from "./controls/ListGroup";
import LinkButton from "./controls/LinkButton";
import TrashIcon from "./icon/TrashIcon";
import TypeaheadField from "./controls/TypeaheadField";
import PlusIcon from "./icon/PlusIcon";
import { crearEtiquetaTecnologia } from "../utils/data";

export function TecnologiaTratamientoForm({
  value,
  append,
  remove,
  tecnologias,
  disabled,
}) {
  const { t } = useTranslation();
  const handleTecnologiaChange = (form) => (event) => {
    event.preventDefault();
    form.setFieldValue("tecnologia", event.target.value || null, true);
  };
  const validarTecnologiaTratamiento = (values) => {
    const errors = {};
    if (!values.tecnologia || Object.keys(values).length === 0) {
      errors.tecnologia =
        "errors.plantaTratamiento.tecnologias.tecnologia.required";
    }
    return errors;
  };
  const handleSubmit = (values, { resetForm }) => {
    append(values.tecnologia);
    resetForm({ values: { tecnologias: null } });
  };
  return (
    <ListGroup>
      {value.map((tecnologia, index) => (
        <ListGroupItem key={tecnologia.codigo}>
          <Grid>
            <Row style={{ display: "flex", flexWrap: "wrap" }}>
              <Col lg={1}>
                <Label>{index + 1}</Label>
              </Col>
              <Col lg={10}>
                <Label>{crearEtiquetaTecnologia(tecnologia)}</Label>
              </Col>
              <Col lg={1}>
                {index === value.length - 1 && (
                  <LinkButton
                    sm
                    style={{ margin: 0, fontSize: "16px" }}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(index);
                    }}
                    disabled={disabled}
                  >
                    <TrashIcon />
                  </LinkButton>
                )}
              </Col>
            </Row>
          </Grid>
        </ListGroupItem>
      ))}
      <ListGroupItem>
        <Formik
          initialValues={{ tecnologia: null }}
          validateOnChange={true}
          validate={validarTecnologiaTratamiento}
          onSubmit={handleSubmit}
        >
          {(form) => (
            <Grid>
              <Row style={{ display: "flex", flexWrap: "wrap" }}>
                <Col lg={1}>
                  <Label>*</Label>
                </Col>
                <Col lg={10}>
                  <TypeaheadField
                    id="plantaTratamiento_tecnologias_tecnologia"
                    name="tecnologia"
                    style={{
                      margin: 0,
                    }}
                    value={form.values.tecnologia}
                    options={tecnologias}
                    valueAttr="codigo"
                    labelAttr={crearEtiquetaTecnologia}
                    emptyLabel="..."
                    onChange={handleTecnologiaChange(form)}
                    isInvalid={isInvalid("tecnologia", form)}
                    error={t(form.errors.tecnologia)}
                    disabled={disabled}
                  />
                </Col>
                <Col lg={1}>
                  <LinkButton
                    sm
                    style={{ margin: 0, fontSize: "16px" }}
                    onClick={(event) => {
                      event.preventDefault();
                      form.submitForm();
                    }}
                    disabled={disabled}
                  >
                    <PlusIcon />
                  </LinkButton>
                </Col>
              </Row>
            </Grid>
          )}
        </Formik>
      </ListGroupItem>
    </ListGroup>
  );
}
